import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import {
  NgSignaturePadOptions,
  SignaturePadComponent,
  AngularSignaturePadModule
} from '@almothafar/angular-signature-pad';
import { SignatureService } from '../services/signature.service';
import { SignableStage } from '../../models/signature';
import { MatDialog } from '@angular/material/dialog';
import { TermsDialogComponent } from '../dialogs/terms-dialog/terms-dialog.component';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { StepperOrientation } from '@angular/cdk/stepper';
import { KeyValuePairComponent } from '../general/key-value-pair/key-value-pair.component';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';
import {
  MatStepper,
  MatStep,
  MatStepperNext,
  MatStepLabel,
  MatStepperPrevious
} from '@angular/material/stepper';

@Component({
  selector: 'app-signature-capture',
  templateUrl: './signature-capture.component.html',
  styleUrls: ['./signature-capture.component.scss'],
  providers: [SignatureService],
  standalone: true,
  imports: [
    MatStepper,
    MatStep,
    MatButton,
    MatStepperNext,
    MatStepLabel,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatStepperPrevious,
    AngularSignaturePadModule,
    KeyValuePairComponent
  ]
})
export class SignatureCaptureComponent implements AfterViewInit {
  @ViewChild('container')
  container: ElementRef;
  @ViewChild('signature')
  signaturePad: SignaturePadComponent;
  noSignature = true;

  @Input()
  signableId: number;

  @Input()
  signableStage: SignableStage;

  @Input()
  signableType: 'docket' | 'booking' | 'saleDocket' = 'docket';

  @Input() deliveryId: number | null = null;

  @Output()
  signatureSaved = new EventEmitter();

  @Output()
  cancel = new EventEmitter();

  signaturePadOptions: NgSignaturePadOptions = {
    // passed through to szimek/signature_pad constructor
    minWidth: 0.5,
    maxWidth: 2.5,
    canvasWidth: 500,
    canvasHeight: 150,
    dotSize: 0.2,
    backgroundColor: 'white'
  };
  printName = new FormControl<string>(null, Validators.required);
  drawn = new FormControl<boolean>(null, Validators.required);

  imageData = null;

  // drawForm = new FormGroup({
  //   drawn: new FormControl<boolean>(null, Validators.required)
  // });
  stepperOrientation: StepperOrientation = 'vertical';

  constructor(
    private signatureService: SignatureService,
    private dialog: MatDialog
  ) {}

  ngAfterViewInit() {
    this.resetSignature();
    // this.signaturePad is now available
    // this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
  }

  drawComplete(event: MouseEvent | Touch) {
    // will be notified of szimek/signature_pad's onEnd event
    this.imageData = this.signaturePad.toDataURL();
    this.noSignature = false;
  }

  drawStart(event: MouseEvent | Touch) {
    this.drawn.setValue(true);
    // will be notified of szimek/signature_pad's onBegin event
  }

  submit() {
    this.signatureService
      .saveSignature({
        signable_type: this.signableType,
        signable_id: this.signableId,
        image_encoded: this.imageData,
        print_name: this.printName.value,
        stage: this.signableStage,
        delivery_id: this.deliveryId
      })
      .subscribe(() => {
        this.signatureSaved.emit(this.imageData);
        this.resetSignature();
      });
  }

  saveAndClose() {
    this.submit();
  }

  resetSignature() {
    this.signaturePad.clear();
    this.noSignature = true;
  }

  openTermsDialog() {
    this.dialog.open(TermsDialogComponent);
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event: any) {
    const orientation = event.target?.screen?.orientation?.type;
    if (!orientation) {
      return;
    }
    if (orientation === 'landscape-primary') {
      this.stepperOrientation = 'horizontal';
    } else {
      this.stepperOrientation = 'vertical';
    }
  }
}
